"use client";

import { WSLogoLarge } from "@/assets/Icons";
import Link from "next/link";
import React from "react";

interface ISecondaryHeader {
  secondaryHeader: {
    callUs: string;
    fontWeightStyle: string;
    callNumber: string;
    callMessage: string;
  };
}

const TopBarSimpleHeader: React.FC<ISecondaryHeader> = ({ secondaryHeader }) => {
  const callUsInfo = secondaryHeader;

  return (
    <>
      <div
        className="w-full flex mx-auto xl:max-w-screen-2xl lg:max-w-screen-xl sm:max-w-screen-md md:max-w-screen-lg lg:py-4 md:py-10 sm:py-4 px-4 lg:px-8 xl:px-20 2xl:px-[104px] items-center"
        id="unbounce_header"
      >
        <div className="basis-1/2">
          <div className="left_side_logo">
            <Link className="w-fit block" href="/">
              <WSLogoLarge />
            </Link>
          </div>
        </div>
        <div className="basis-1/2 flex items-center justify-end">
          <div className="right_side_text text-base/8">
            {callUsInfo?.callUs} <span className={`font-${callUsInfo?.fontWeightStyle}`}>{callUsInfo?.callNumber}</span>{" "}
            {callUsInfo?.callMessage}
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBarSimpleHeader;
